module.exports = __webpack_public_path__ + "img/tlog.32406297.jpg";